export default "__VITE_ASSET__BzFr5Xoz__"